module.exports = __webpack_public_path__ + "img/west_indies_icc.e79f7132.png";